import { Button } from '@successmode-ktp/kui';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { REFUND_DETAIL_TEXT } from '@repo/constants';

type Props = {
  nation: string;
  refund: number;
  remittance: number;
  van: number;
  unRefund: number;
  onClose: () => void;
};

export const RefundDetail = ({
  nation,
  refund,
  remittance,
  van,
  unRefund,
  onClose,
}: Props) => {
  const [language, setLanguage] = useState<'KOR' | 'ENG'>('ENG');
  useEffect(() => {
    const newNation = nation === 'KOR' ? nation : 'ENG';
    setLanguage(newNation);
  }, [nation]);

  return (
    <BackDrop>
      <Modal>
        <Title>{REFUND_DETAIL_TEXT[language].title}</Title>
        <DataListWrapper>
          <DataList $bgColor='#e9f0fe'>
            <DataWrapper $color='#246CF6' $fontWeight='600'>
              <dt>{REFUND_DETAIL_TEXT[language].refund}</dt>
              <dd>{refund?.toLocaleString()} KRW</dd>
            </DataWrapper>
            {remittance > 0 && (
              <DataWrapper $color='#777' $fontWeight='400'>
                <dt>{REFUND_DETAIL_TEXT[language].remittance}</dt>
                <dd>{remittance?.toLocaleString()} KRW</dd>
              </DataWrapper>
            )}
            {van > 0 && (
              <DataWrapper $color='#777' $fontWeight='400'>
                <dt>{REFUND_DETAIL_TEXT[language].van}</dt>
                <dd>{van?.toLocaleString()} KRW</dd>
              </DataWrapper>
            )}
          </DataList>
          <DataList $bgColor='#F4F4F4'>
            <DataWrapper $color='#030303' $fontWeight='600'>
              <dt>{REFUND_DETAIL_TEXT[language].unRefund}</dt>
              <dd>{unRefund?.toLocaleString()} KRW</dd>
            </DataWrapper>
          </DataList>
        </DataListWrapper>
        <Button type='button' onClick={onClose}>
          {REFUND_DETAIL_TEXT[language].close}
        </Button>
      </Modal>
    </BackDrop>
  );
};

const BackDrop = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.5);
  z-index: 200;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const Modal = styled.div`
  padding: 20px;
  flex-direction: column;
  align-items: center;
  min-width: 330px;
  max-width: 340px;
  width: 90%;
  background-color: white;
  border-radius: 8px;
  width: 90%;
`;

const Title = styled.h6`
  color: #030303;
  font-size: 16px;
  font-weight: 600;
  line-height: 150%;
  letter-spacing: -0.32px;
`;

const DataListWrapper = styled.div`
  display: flex;
  flex-direction: column;
  gap: 8px;
  margin: 16px 0 24px;
`;

const DataList = styled.dl<{ $bgColor: string }>`
  display: flex;
  flex-direction: column;
  gap: 6px;
  padding: 16px;
  border-radius: 12px;
  background: ${({ $bgColor }) => $bgColor};
`;

const DataWrapper = styled.div<{
  $color: string;
  $fontWeight: string;
}>`
  display: flex;
  justify-content: space-between;
  align-items: center;
  align-self: stretch;
  color: ${({ $color }) => $color};
  font-size: 14px;
  font-weight: ${({ $fontWeight }) => $fontWeight};
  letter-spacing: -0.28px;
  line-height: 21px;
`;
